import React from 'react';
import { ShieldAlert, Lock, AlertTriangle } from 'lucide-react';

class QSLMErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null, is403: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex items-center justify-center" data-testid="qslm-error-boundary">
          <div className="bg-[#1A0A0A] border border-red-900/50 rounded-lg p-8 max-w-lg text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-red-900/20 flex items-center justify-center">
                <ShieldAlert className="w-8 h-8 text-red-500" />
              </div>
            </div>
            <h3 className="text-lg font-semibold text-red-400 mb-2 font-[Orbitron]">
              QSLM SECURE BOUNDARY
            </h3>
            <p className="text-gray-400 text-sm">
              Input rejected. Protected Health Information (PHI) or personal data detected.
              This request has been terminated at the Front-Door.
            </p>
            <div className="mt-4 flex items-center justify-center gap-2 text-xs text-gray-600">
              <Lock className="w-3 h-3" />
              <span>HIPAA Compliant Rejection</span>
            </div>
            <button
              onClick={() => this.setState({ hasError: false, errorInfo: null })}
              className="mt-6 px-4 py-2 bg-red-900/30 border border-red-800/50 rounded text-red-400 text-sm hover:bg-red-900/50 transition-colors"
              data-testid="qslm-retry-btn"
            >
              Acknowledge & Retry
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Inline 403 rejection component for API responses
export function QSLM403Display({ message, onDismiss }) {
  return (
    <div className="bg-[#1A0505] border border-red-900/40 rounded-lg p-6 animate-pulse-slow" data-testid="qslm-403-display">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-full bg-red-900/30 flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-red-500" />
        </div>
        <div className="flex-1">
          <h4 className="text-red-400 font-semibold text-sm font-[Orbitron] tracking-wider">
            QSLM REJECTION — 403
          </h4>
          <p className="text-gray-400 text-xs mt-1">
            {message || "Protected Health Information (PHI) or personal data detected. Payload terminated at Front-Door."}
          </p>
          <div className="mt-3 flex items-center gap-3">
            <span className="text-[10px] text-gray-600 flex items-center gap-1">
              <Lock className="w-3 h-3" /> HIPAA / QSLM Enforced
            </span>
            {onDismiss && (
              <button onClick={onDismiss} className="text-[10px] text-red-500 hover:text-red-400 underline">
                Dismiss
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QSLMErrorBoundary;
